import { AspectRatio, Box, Image } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { MakeCard } from "@/components/elements";

import type { AuctionCarTransaction } from "@/types/auctions";
import type { FC } from "react";

interface Props {
  title: string;
  currentTransaction: AuctionCarTransaction;
  makeName: string | undefined;
}

export const AuctionDescriptionHeader: FC<Props> = ({ title, currentTransaction, makeName }) => {
  const { t } = useTranslation();

  return (
    <Box
      style={{
        display: "grid",
        gridTemplate: "1fr / 1fr",
      }}
    >
      <AspectRatio
        ratio={16 / 9}
        style={{
          borderRadius: "var(--mantine-radius-md)",
          overflow: "hidden",
          gridArea: "1 / 1",
        }}
      >
        <Image
          src={currentTransaction.more.image}
          fit="cover"
          alt={title || t("components.TransactionsTable.transaction_details")}
        />
      </AspectRatio>
      {makeName && (
        <Box
          p="md"
          style={{
            gridArea: "1 / 1",
            alignSelf: "start",
            justifySelf: "start",
            position: "sticky",
            top: 0,
            zIndex: 2,
            width: "fit-content",
          }}
        >
          <MakeCard w={40} make={makeName} FallbackComponent={<Box />} />
        </Box>
      )}
    </Box>
  );
};
